<span
  class="wp-replacement-label"
  (click)="activate($event)"
  tabindex="-1"
  attr.data-test-selector="{{fieldName}}">
  <ng-content></ng-content>
</span>
